import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  withStyles,
} from '@material-ui/core';
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import BuzzLabel from '../BuzzLabel/BuzzLabel';

const CustomTextField = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      minHeight: 44,
      maxHeight: 52,
      '& fieldset': {
        borderColor: theme.palette.buzzBorder,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.buzzBreadCrumb,
      },
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      '& fieldset': {
        borderColor: theme.palette.buzzBorder,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.buzzBorder,
      },
    },
    '& .MuiInputBase-root.Mui-disabled': {
      background: theme.palette.buzzLiteGray,
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.buzzDisableInputColor,
    },
  },
}))(TextField);

const BuzzInput = ({
  placeholder = '',
  variant = 'outlined',
  onChange,
  fullWidth = true,
  disabled = false,
  inputProps,
  classes,
  value = '',
  id = new Date().toString() + Math.random() * 10000,
  required = false,
  label = '',
  flex = 1,
  type = 'text',
  autoFocus = false,
  autoComplete = 'off',
  name,
  onBlur,
  onFocus,
  error,
  helperText,
  size,
  width,
  select = false,
  mr,
  ml,
  mb,
  mt,
  mx,
  my,
  m,
  p,
  pl,
  pr,
  px,
  py,
  pt,
  pb,
  bgcolor = 'white',
  forwardRef,
  search = false,
  onSubmitEditing = () => {},
  ...props
}) => {
  return (
    <Box
      flex={flex}
      m={m}
      mx={mx}
      my={my}
      mr={mr}
      ml={ml}
      mb={mb}
      mt={mt}
      p={p}
      px={px}
      py={py}
      pt={pt}
      pb={pb}
      pl={pl}
      pr={pr}
      width={width}
      // bgcolor={bgcolor}
    >
      <BuzzLabel label={label} required={required} id={id} />
      <Box flex={1} bgcolor={bgcolor} borderRadius={4}>
        <CustomTextField
          ref={forwardRef}
          id={id}
          name={name}
          classes={classes}
          onChange={onChange}
          placeholder={placeholder}
          variant={variant}
          fullWidth={fullWidth}
          disabled={disabled}
          value={value}
          type={type}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          onBlur={onBlur}
          onFocus={onFocus}
          error={error}
          helperText={helperText}
          size={size}
          select={select}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onSubmitEditing();
            }
          }}
          InputProps={
            search
              ? {
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        aria-label="search icon button"
                        onClick={onSubmitEditing}
                        edge="start">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              : null
          }
          {...props}
        />
      </Box>
    </Box>
  );
};

export default BuzzInput;
